import { portalApi as api } from "@services/api/portalApi"
import { MinimalDriveItem } from "@godalming/api-types"

export async function fetchParentDocuments(): Promise<MinimalDriveItem> {
    try {
        const response = await api.get(`/documents`)
        return response.data
    } catch (error) {
        console.error("Error fetching parent documents:", error)
        throw error
    }
}

export async function fetchParentDocumentFolderById(folderId: string): Promise<MinimalDriveItem> {
    try {
        const response = await api.get(`/documents/folder/${folderId}`)
        return response.data
    } catch (error) {
        console.error(`Error fetching folder with ID ${folderId}:`, error)
        throw error
    }
}

